import { H3, ProgressBar, IProgressBarProps } from 'components'

interface IUploadFilesMessage extends IProgressBarProps {
  message?: string
}

export const UploadFilesMessage = ({
  message,
  ...passingProps
}: IUploadFilesMessage) => {
  return (
    <>
      <H3>Uploading {message}</H3>

      <ProgressBar {...passingProps} />
    </>
  )
}
